module.exports = __webpack_public_path__ + "static/media/tooMuchHair2009.c46b42bc.jpg";